import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { UseFindTheObject } from '../providers/FindTheObjectProvider/types';
import { FindTheObjectContext } from '../providers/FindTheObjectProvider';

export const useFindTheObject = (): UseFindTheObject => {
  const [state, dispatch] = useContextWithErrorHandler(
    FindTheObjectContext,
    'FindTheObjectProvider'
  );
  return [state, dispatch];
};
